import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';
import Timeline from './Timeline';
import ProfilePic from '../images/ProfilePic.jpeg';
import Skills from './Skills';

const About = () => {
  const heroRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: heroRef,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], [-200, 200]);
  y.on('change', (value) => console.log('Parallax Y:', value));
  scrollYProgress.on('change', (value) => console.log('Scroll Progress:', value));

  return (
    <>
      <div className="min-h-screen bg-white">
        <div className="max-w-7xl mx-auto px-4 py-8">
          {/* Hero Section */}
          <header ref={heroRef} className="mb-24 md:mb-32 px-4 sm:px-0">
            <div className="grid md:grid-cols-2 gap-12 md:gap-24 items-center">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >
                <h1 className="text-4xl md:text-8xl font-light text-gray-900 mb-6">
                  Building Digital
                  <span className="block text-gray-600 mt-2">Experiences</span>
                  <span className="block text-gray-900 mt-2">Not Just Code</span>
                </h1>
                <p className="text-xl text-gray-600 max-w-2xl">
                  Bridging technical excellence with human-centered design through thoughtful
                  digital solutions.
                </p>
              </motion.div>

              <motion.div
                className="relative max-w-md md:max-w-xl aspect-[3/4] overflow-hidden"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <motion.div
                  style={{ y }}
                  className="absolute inset-0 bg-gray-100"
                >
                  <img
                    src={ProfilePic}
                    alt="Profile"
                    className="w-full h-full object-cover"
                    onError={() => console.error('ProfilePic failed to load')}
                  />
                </motion.div>
              </motion.div>
            </div>
          </header>

          {/* Divider */}
          <div className="border-t border-gray-200 my-24 md:my-32" />

          {/* Skills Section */}
          <Skills />

          {/* Philosophy Section */}
          {/* <section className="px-4 sm:px-0 mb-24 md:mb-32">
            <div className="max-w-3xl">
              <h3 className="text-xs text-gray-500 font-medium mb-8 uppercase tracking-wider">
                Design Philosophy
              </h3>
              <div className="space-y-6 text-lg text-gray-600">
                <p>
                  I create interfaces that disappear - technology should enhance human interaction,
                  not compete with it. Every pixel and line of code serves a purpose in crafting
                  intuitive, accessible experiences.
                </p>
                <p>
                  My work balances aesthetic purity with functional robustness, ensuring solutions
                  are both beautiful and built to last.
                </p>
              </div>
            </div>
          </section> */}

          {/* Divider */}
          {/* <div className="border-t border-gray-200 my-24 md:my-32" /> */}

          {/* Experience Section */}
          {/* <section className="px-4 sm:px-0">
            <div className="grid md:grid-cols-2 gap-12 md:gap-24">
              <div>
                <h3 className="text-xs text-gray-500 font-medium mb-8 uppercase tracking-wider">
                  Approach
                </h3>
                <div className="space-y-6 text-lg text-gray-600">
                  <p>
                    Solutions start with understanding human needs. I combine technical expertise
                    with design thinking to create products that solve real problems.
                  </p>
                </div>
              </div>

              <div>
                <h3 className="text-xs text-gray-500 font-medium mb-8 uppercase tracking-wider">
                  Collaboration
                </h3>
                <div className="space-y-6 text-lg text-gray-600">
                  <p>
                    Great work happens in teams. I partner with designers, product managers,
                    and stakeholders to bring visions to life through iterative development.
                  </p>
                </div>
              </div>
            </div>
          </section> */}

          {/* Timeline Section */}
          <Timeline />
        </div>
      </div>
    </>
  );
};

export default About;